import { alert, popupType } from "./Alert";
import { Dialog } from "./Dialog/Dialog";

export const LOADER_FULLPAGE = "fullpage";
type LoaderType = undefined | string | "fullpage";

export interface AjaxRequestOptions {
    loader?: LoaderType,
    callback?: () => void
}

export class Api {
    loader: undefined | string = undefined;

    showLoader = (options?: AjaxRequestOptions) => {
        const loaderContainer = this.getLoaderContainer(options);
        if (loaderContainer) {
            const loaderElement = document.getElementById(loaderContainer) as HTMLInputElement;
            loaderElement.style.setProperty("display", "inline-block", "important");
        }
    }

    hideLoader = () => {
        const loaderContainer = this.getLoaderContainer();
        if (loaderContainer) {
            const loaderElement = document.getElementById(loaderContainer) as HTMLInputElement;
            loaderElement.style.setProperty("display", "none", "important");
        }
    }

    public showMessage = (message: string, type = popupType.DANGER) => {
        this.hideLoader();
        alert.show({
            content: message,
            type: type
        });
    }

    public showDialogMessage = (title: string, error: string) => {
        this.hideLoader();
        const dialog = new Dialog(title, `<p>${error}</p>`);
        dialog.show();
    }

    private getLoaderContainer = (options?: AjaxRequestOptions) => {
        this.loader = options?.loader ?? this.loader;
        return this.loader == LOADER_FULLPAGE ? "ajax-loader" : this.loader;
    }
}